
//////////////////////////////////////////
/////////////////HEADER///////////////////
//////////////////////////////////////////

////////HEADER MENU BUTTON

//add to button to give the ability to hide or show the mobile header nav
function toggleVisibilityHeaderContainer() {
  //store the (hidden by default) mobile header navigation menu in a variable
  var mobileHeaderMenuContainer = document.getElementById("mobile-header-nav"); 
  
  //figure out how many items are in the menu
  var mobileHeaderMenuItems = $('#mobile-header-nav li').length;
  
  //set the menu height to be 50 * how ever many items are in the menu
  var menuHeight = (mobileHeaderMenuItems * 50)

  //convert the menu height to a string with px at the end so it can be used
  var menuHeightString = menuHeight + "px";
  
  //if the menu is currently hidden (height set to 0 px) 
  //make it visable by setting the height to the previously determined height
  //note: we use height 0 instead of display none to allow for a growing effect
  //the growing effect is set on the #mobile-header-nav element in css
  if(mobileHeaderMenuContainer.style.height == '0px'){
    mobileHeaderMenuContainer.style.height = menuHeightString;
    //scrollToElementById("header-menu-icon-container");
  }
  //if the menu is visable, clicking it again should make it invisable
  else{
    mobileHeaderMenuContainer.style.height = '0px';
  }

    
}

/*

function scrollToElementById(id){
  $('html,body').animate({scrollTop: $("#"+id).offset().top},'slow');
}

*/



///////////////////////////////////////////////
/////////////////SEARCH PAGE///////////////////
///////////////////////////////////////////////


//////toggle whether filters are visable on mobile////////////

//this function is added to the filters button that show up on mobile
//this will toggle an active or inactive class for the collectionFilters element
//css will then be used to display or show the collection filters menu on mobile based on active or inactive
function toggleVisibilityMobileFilters() {
  collectionFilters = document.getElementById("collectionFilters");

  if($('#collectionFilters').hasClass('inactive')){
    $('#collectionFilters').removeClass( "inactive" ).addClass( "active" )
  }
  else{
    $('#collectionFilters').removeClass( "active" ).addClass( "inactive" )
  }

}




///////////////MOBILE STICKY FUNCTIONALITY////////////////////



//the following will run any time a page is scrolled anywhere
$(window).scroll(function() {

  //first check if the page is small enough to be mobile
  if (window.innerWidth < 768) { 

    //first get the search bar (which is stored in #header-search-col)
    var searchBar = document.getElementById("header-search-col");
    //then find out where the #header-search-row is to know where to activate and deactivate... 
    //the sticky effect for the search bar as they are at the same height
    //note: the search bar itself can't be used as once it's sticky it's distance from the top changes
    var searchBarActivationHeight = $("#header-search-row").offset().top;
    
    //add or remove the mobile-sticky class based on the current scroll height
    makeSticky(searchBar, searchBarActivationHeight);

    //the col-12 bootstrap class was causing issues for the search bar when sticky so it needed to be removed
    //when the search bar becomes sticky
    removeClassPastScroll(searchBar, searchBarActivationHeight, "col-12");

    //check if we're on the search page because if we're not, looking for the sidebar... 
    //will cause a javascript error
    if(window.location.href.includes("/search?")){

      //this is used to figure out where the bottom of the header is so we know where to activate
      //the sticky effect for the filter button and menu
      var headerHeight = $('#header-row').outerHeight(true);


      //where to activate the filter button sticky functionality
      //the - 45 is included to account for the search bar being stuck to the top 
      var filterButtonActivationHeight = (headerHeight - 45);

      //get the filter button
      var filterButton = document.getElementById("show-search-filters-button");
      //add and remove the class that makes it sticky
      makeSticky(filterButton, filterButtonActivationHeight);


      //where to activate the collection filters menu (sidebar menu) sticky functionality
      //the - 45 is included to account for the search bar being stuck to the top 
      var stickyFiltersActivationHeight = (headerHeight - 45);

      //get the collection filters menu (sidebar menu)
      var collectionFilters = document.getElementById("collectionFilters");
      //add and remove the class that makes it sticky
      makeSticky(collectionFilters, stickyFiltersActivationHeight);

      
    }

  }else{
    //make sure if the width of the page is greater than mobile size we remove any changes
    //that may have been made if the page was previously mobile size
    undoMobileSticky();
  }
  

});




//this function will be used to undo any changes that may have been made if the page was previously mobile size
//note most of the functionality will be undone using css media queries
function undoMobileSticky(){
  //make sure search bar has col-12 that is removed when making it sticky
  var $searchBar = $('#header-search-col');
  if(!$searchBar.hasClass("col-12")){
    $searchBar.addClass("col-12");
  }

}


//this function adds an removes the "mobile-sticky" class from an element that gives it the sticky functionality 
//based on how far the page has been scrolled
function makeSticky(element, activateLocation){
  if (window.pageYOffset >= activateLocation) {
    element.classList.add("mobile-sticky")
  } else {
    element.classList.remove("mobile-sticky");
  }
}

//this function is used to remove classes that cause an issue with sticky elements at the point where the element becomes sticky
function removeClassPastScroll(element, removeLocation, className){
  if (window.pageYOffset >= removeLocation) {
    element.classList.remove(className);
  } else {
    element.classList.add(className);
  }
}



///////////////end mobile sticky elements////////////////////